import { createContext, useContext } from 'react';

export const TranslationContext = createContext();

function useTranslationContext() {
  return useContext(TranslationContext);
}

export default useTranslationContext;
